export const CONTENT_LIBRARY_ITEM_FILTER_DEFINITIONS = [
  {
    key: 'recipient',
    id: 'contentLibraryRecipientFilter',
    label: 'Recipient',
    placeholder: 'Recipient',
    selectedValuePrefix: 'Recipient',
    options: [
      { label: 'Agency', value: 'Agency' },
      { label: 'Employer', value: 'Employer' }
    ]
  },
  {
    key: 'lawScope',
    id: 'contentLibraryLawScopeFilter',
    label: 'Law Scope',
    placeholder: 'Law Scope',
    selectedValuePrefix: 'Law Scope',
    options: [
      { label: 'Federal', value: 'Federal' },
      { label: 'State', value: 'State' }
    ]
  }
]

export const CONTENT_LIBRARY_ITEM_SORT_OPTIONS = [
  { label: 'Document Name A-Z', value: 'document-name-a-z' },
  { label: 'Recently Added', value: 'recently-added' },
  { label: 'My Recently Downloaded', value: 'my-recently-downloaded' },
  { label: 'My Frequently Downloaded', value: 'my-frequently-downloaded' },
  { label: 'My Favorites', value: 'my-favorites' }
]

export const CONTENT_LIBRARY_ITEM_DEFAULT_SORT = 'document-name-a-z'
